function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import classNames from "classnames";
var ProgressDisplay = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ProgressDisplay, Component);
    var _super = _createSuper(ProgressDisplay);
    function ProgressDisplay() {
        _classCallCheck(this, ProgressDisplay);
        return _super.apply(this, arguments);
    }
    var _proto = ProgressDisplay.prototype;
    _proto.render = function render() {
        var _this_props = this.props, compact = _this_props.compact, val = _this_props.val, maxVal = _this_props.maxVal, onActivate = _this_props.onActivate;
        var circum = 2 * 13.5 * Math.PI;
        var prog = 1 / maxVal * val;
        var classes = classNames("progress-display", {
            "progress-display--compact": compact
        });
        var roundedProgress = Math.min(100, Math.floor(prog * 100));
        var handleKeyboardActivation = function(e) {
            if (onActivate && (e.key === " " || e.key === "Enter")) {
                onActivate();
            }
        };
        return /*#__PURE__*/ React.createElement("div", {
            tabIndex: onActivate ? 0 : -1,
            className: classes,
            role: "progressbar",
            "aria-valuenow": roundedProgress,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            onKeyDown: handleKeyboardActivation,
            onClick: onActivate
        }, /*#__PURE__*/ React.createElement("span", {
            className: "progress-display__svg"
        }, /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            version: "1.1",
            width: "40",
            height: "40"
        }, /*#__PURE__*/ React.createElement("circle", {
            className: "progress-display__background",
            r: "13.5px",
            cx: "20",
            cy: "20",
            fill: "transparent",
            strokeDasharray: "".concat(circum, "px"),
            strokeDashoffset: "".concat(circum / 3, "px")
        }), /*#__PURE__*/ React.createElement("circle", {
            className: "progress-display__bar",
            r: "13.5px",
            cx: "20",
            cy: "20",
            fill: "transparent",
            strokeDasharray: "".concat(circum, "px"),
            strokeDashoffset: "".concat(circum / 3 + circum / 3 * 2 * (1 - prog), "px")
        }))), /*#__PURE__*/ React.createElement("span", {
            className: "perc-val",
            "aria-hidden": true
        }, roundedProgress + "%"));
    };
    return ProgressDisplay;
}(Component);
export default ProgressDisplay;
